// ===== 2. React Hook for Soft Approval =====
// src/hooks/useSoftApproval.ts

import { useState, useEffect } from 'react';
import { AISoftApprovalService, SoftApprovalAnalysis } from '../../../../services/ai/aiSoftApprovalService';

export const useSoftApproval = (applicationData: any, triggerAnalysis = false) => {
  const [analysis, setAnalysis] = useState<SoftApprovalAnalysis | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!triggerAnalysis || !applicationData) {
      return;
    }

    const performAnalysis = async () => {
      setLoading(true);
      setError(null);

      try {
        const aiService = new AISoftApprovalService();
        const result = await aiService.getSoftApprovalAnalysis(applicationData);
        setAnalysis(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to analyze application');
      } finally {
        setLoading(false);
      }
    };

    // Small delay to ensure component is mounted
    const timeoutId = setTimeout(performAnalysis, 500);
    return () => clearTimeout(timeoutId);

  }, [applicationData, triggerAnalysis]);

  const retryAnalysis = () => {
    if (applicationData) {
      setAnalysis(null);
      setError(null);
      // Trigger re-analysis by updating a dependency
      const timeoutId = setTimeout(() => {
        setLoading(true);
        const aiService = new AISoftApprovalService();
        aiService.getSoftApprovalAnalysis(applicationData)
          .then(setAnalysis)
          .catch(err => setError(err.message))
          .finally(() => setLoading(false));
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  };

  return { analysis, loading, error, retryAnalysis };
};

//---------------------------------------------------------------------------------------------------------------------------------------------------